namespace RioERP.Web.Enums {
    export enum OrderStatus {
        Placed = 1,
        Pending = 2,
        Processing = 3,
        Processed = 4,
        Complete = 5,
        Cancelled = 6,
        CompleteAndDelivered = 7
    }
    Serenity.Decorators.registerEnumType(OrderStatus, 'RioERP.Web.Enums.OrderStatus');
}
